var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"vue-host"}},[(_vm.showRoundPanel)?_c('HostRound',{attrs:{"round":_vm.renderedRound,"gameInstanceId":_vm.gameInstanceId,"timer":_vm.roundTimer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }